import React from "react";
import { Link } from "react-router-dom";
import "./components/NeoLoanCards.css";

const loanData = [
  {
    id: "home-loan",
    icon: "bi bi-house-door",
    category: "Home Finance",
    title: "Home Loan",
    rate: "7.10%*",
    description:
      "Competitive home loan solutions with complete assistance from application to disbursement.",
    features: [
      "Competitive interest rates from leading banks",
      "Public sector bank loan options",
      "Flexible EMI and repayment options",
      "Zero processing fees on selected offers",
      "Complete doorstep assistance",
    ],
    applyLabel: "Apply for Home Loan",
  },
  {
    id: "loan-against-property",
    icon: "bi bi-building",
    category: "Property Finance",
    title: "Loan Against Property",
    rate: "7.90%*",
    description:
      "Unlock the financial value of your residential or commercial property.",
    features: [
      "High-value funding against eligible property",
      "Attractive interest rates based on profile",
      "Flexible tenure and repayment options",
      "Support with valuation and documentation",
      "End-to-end doorstep service",
    ],
    applyLabel: "Apply for Property Loan",
  },
  {
    id: "commercial-loan",
    icon: "bi bi-buildings",
    category: "Commercial Finance",
    title: "Commercial Loan",
    rate: "8.40%*",
    description:
      "Flexible funding solutions for purchasing or refinancing commercial property.",
    features: [
      "Funding for eligible commercial properties",
      "Solutions for offices, shops and business premises",
      "Flexible loan tenure options",
      "Transparent documentation support",
      "Assistance from application to disbursement",
    ],
    applyLabel: "Apply for Commercial Loan",
  },
  {
    id: "personal-loan",
    icon: "bi bi-person-check",
    category: "Personal Finance",
    title: "Personal Loan",
    rate: "9.99%*",
    description:
      "Quick and convenient financing for personal requirements without collateral.",
    features: [
      "Fast application processing",
      "Minimal documentation for eligible applicants",
      "Flexible repayment tenure",
      "No collateral required",
      "Support for urgent personal financial needs",
    ],
    applyLabel: "Apply for Personal Loan",
  },
  {
    id: "business-loan",
    icon: "bi bi-briefcase",
    category: "Business Finance",
    title: "Business Loan",
    rate: "9.00%*",
    description:
      "Funding support for working capital, equipment purchases and business expansion.",
    features: [
      "Funding for startup and business expansion",
      "Working capital and inventory support",
      "Flexible repayment plans",
      "Competitive lender comparison",
      "Quick documentation and processing assistance",
    ],
    applyLabel: "Apply for Business Loan",
  },
  {
    id: "car-loan",
    icon: "bi bi-car-front",
    category: "Vehicle Finance",
    title: "Car Loan",
    rate: "7.45%*",
    description:
      "Drive your new car with flexible finance options from leading banks.",
    features: [
      "Finance options for eligible new cars",
      "Competitive interest rates",
      "Minimal documentation",
      "Flexible repayment tenure",
      "Quick approval and disbursal assistance",
    ],
    applyLabel: "Apply for Car Loan",
  },
];

const NeoLoanCards = () => {
  return (
    <section
      className="neo-loan-section"
      aria-labelledby="neo-loan-section-title"
    >
      <div className="neo-loan-background-glow neo-glow-left"></div>
      <div className="neo-loan-background-glow neo-glow-right"></div>

      <div className="neo-loan-section-container">
        <div className="neo-loan-section-header">
          <span className="neo-loan-eyebrow">
            Compare Loan Products
          </span>

          <h2 id="neo-loan-section-title">
            Choose the right loan for
            <span> your financial goals</span>
          </h2>

          <p>
            Explore suitable loan products, compare key benefits and apply
            online with complete assistance from Monayra.
          </p>
        </div>

        <div className="neo-card-container">
          {loanData.map((card, index) => (
            <article
              className="neo-card"
              key={card.id}
              style={{ "--neo-card-index": index }}
            >
              <div className="neo-card-border"></div>

              <div className="neo-card-content">
                <div className="neo-card-top">
                  <span className="neo-card-icon">
                    <i className={card.icon}></i>
                  </span>

                  <span className="neo-card-category">
                    {card.category}
                  </span>

                  <span className="neo-card-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="neo-card-heading">
                  <h3>{card.title}</h3>

                  <div className="neo-card-rate">
                    <span>Starting at</span>
                    <strong>{card.rate}</strong>
                    <small>per annum</small>
                  </div>
                </div>

                <p className="neo-card-description">
                  {card.description}
                </p>

                <div className="neo-card-divider"></div>

                <ul className="neo-features-list">
                  {card.features.map((feature) => (
                    <li key={feature}>
                      <span className="neo-feature-check">
                        <i className="bi bi-check-lg"></i>
                      </span>

                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="neo-card-actions">
                  <Link
                    to="/apply-now"
                    className="neo-card-apply-btn"
                    aria-label={card.applyLabel}
                  >
                    <span>{card.applyLabel}</span>
                    <i className="bi bi-arrow-right"></i>
                  </Link>

                  <Link
                    to="/contact"
                    className="neo-card-contact-link"
                  >
                    <i className="bi bi-headset"></i>
                    Get Assistance
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="neo-card-scroll-hint">
          <i className="bi bi-arrow-left-right"></i>
          Swipe to explore loan products
        </div>

        <div className="neo-loan-disclaimer">
          <i className="bi bi-info-circle"></i>

          <p>
            *Interest rates are indicative and may vary according to the
            applicant’s profile, credit score, lender policies and prevailing
            market conditions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NeoLoanCards;